import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import Sticky from "react-sticky-el";
import ButtonComponent from "@components/ButtonComponent";
import { ZERO_VALUE } from "@utils/constants";
import { ArrowLeft } from "lucide-react";

const TableHeader = ({
  onRefresh,
  onCorrectiveResults,
  isCorrectionDisabled,
  isLoading,
}) => {
  const { t: translate } = useTranslation();

  return (
    <Sticky
      stickyStyle={{
        top: "77px",
      }}
      stickyClassName="dark:bg-gray-800 bg-white z-[4] w-full dark:shadow-[inset_0px_-3px_6px_#4b5563] shadow-[inset_0px_-3px_6px_#D6D6D6]"
    >
      <div
        className={clsx(
          `opacity-100 py-5 px-5 w-full flex items-center justify-between gap-2 border-b-2 dark:border-gray-700 border-gray-100 transition-all duration-700`
        )}
      >
        <div className="flex w-full gap-2 items-center justify-between flex-1">
          <ArrowLeft
            className="dark:text-white"
            onClick={() => {
              window.location.href = "/exception-list";
            }}
          />

          <div className="flex items-center gap-2">
            <ButtonComponent
              id="refresh-selection"
              color="blue"
              onClick={onRefresh}
              ref={null}
              icon={null}
              text={translate("exception-details.refresh-records")}
              size="sm"
              width="max"
              className="whitespace-nowrap"
            />
            <ButtonComponent
              id="corrective-results"
              color="green"
              disabled={isCorrectionDisabled}
              onClick={onCorrectiveResults}
              ref={null}
              icon={null}
              text={translate("exception-details.corrective-results")}
              size="sm"
              width="max"
            />
          </div>
        </div>
      </div>
    </Sticky>
  );
};

export default TableHeader;
